import "./HousingPressureIndex.module.css";
import Header from "@/reusable_sections/Header";
import Introduction from "./sections/Introduction";
import IndexDetails from "./sections/IndexDetails";
import MonthlyMovement from "./sections/MonthlyMovement";
import OrientalMinimalismPhilosophy from "./sections/OrientalMinimalismPhilosophy";
import Footer from "@/reusable_sections/Footer";
export default function HousingPressureIndexPage() {
  return <div>
      <Header />
      <Introduction />
      <IndexDetails />
      <MonthlyMovement />
      <OrientalMinimalismPhilosophy />
      <Footer />
    </div>;
}